import { InjectionToken } from '@angular/core';

export enum FileTypesCategoryEnum {
  CV = 'cv',
  CL = 'cl',
}

export type FileTypesCategory = `${FileTypesCategoryEnum}`;

export type AcceptedFileTypes = Record<FileTypesCategory, string[]>;

export const ACCEPTED_FILE_TYPES = new InjectionToken<AcceptedFileTypes>('ACCEPTED_FILE_TYPES');
